export function getCaseServiceLog(state) {
  return caseId => {
    return state.caseServiceLogs[caseId]
  };
}



// WEBPACK FOOTER //
// ./src/store/getters/case-service-log.js